exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/admin/admin.component.css
// module id = ../../../../../src/app/admin/admin.component.css
// module chunks = main